import React, { useCallback, useState } from "react";
import * as css from "./QandA.module.scss";
import { FormattedMessage } from "react-intl";

type QandAProps = {
  questions: {
    question: string;
    answer: string;
  }[];
  name: string;
  area: string;
  flag: string;
  lang: `en` | `ja`;
};

const QandA: React.FC<QandAProps> = (prop) => {
  const [showDetail, setShowDetail] = useState(true);

  const toggleInterpreter = useCallback(() => {
    setShowDetail(!showDetail);
  }, [showDetail, setShowDetail]);

  const classQuestions = showDetail
    ? css.questions
    : css.questions + ` ` + css.showLimited;

  return (
    <div>
      <section className={css.interpreterContent}>
        <div className={css.interpreterContent__main}>
          {prop.lang === "ja" ? (
            <h3>
              <small>手書きした人:</small> {prop.name} ({prop.area}{" "}
              <span>{prop.flag}</span>)
            </h3>
          ) : (
            <h3>
              <small>Handwriting by</small> {prop.name} <small>from</small> {prop.area}{" "}
              <span>{prop.flag}</span>
            </h3>
          )}


          <ul className={classQuestions}>
            {prop.questions.map((question, i) => {
              return (
                <li key={i}>
                  <p className={css.questions__q}>{question.question}</p>
                  <p className={css.questions__a}>{question.answer} </p>
                </li>
              );
            })}
          </ul>
        </div>
      </section>
    </div>
  );
};

export default QandA;
